//SVG's
import Facebook from "../svgs/Facebook";
import WhatsApp from "../svgs/WhatsApp";
import Telegram from "../svgs/Telegram";
import Instagram from "../svgs/Instagram";

const useMediaType = () => {

  /**
   *
   * @param {String} media
   * @returns {SVG} of passed media
   */
  const getMediaType = (media) => {
    switch (media) {
      case "Whatsapp":
        return <WhatsApp />;

      case "Instagram":
        return <Instagram />;

      case "Facebook":
        return <Facebook />;

      case "Telegram":
        return <Telegram />;
    }
  }

  return { getMediaType };
}

export default useMediaType;